<div class="row">
  <sb-card [loading]="loading" [loadingDelay]="1" class="col-12">
    <div card-header>
      <div class="tabs">
        <a class="tab-link--active">
          <sb-icon icon="running" class="mr-2"></sb-icon>
          {{'lang.globals.visitorStatistic' | translate}}
        </a>
      </div>
    </div>
    <div card-body>
          <div class="col-12">
            <sb-comp-visitor-tracker-chart [from]="from" [till]="till" [chartHeight]="300" [resolveInCom]="false"
                                           [inputData]="visitorTimeData" [classes]="'noShadow'"
                                           [showChartControl]="true" [hideInterval]="true"
                                           (changedChartControl)="handleChartControlChange($event)"
                                           [halfHeight]="false"></sb-comp-visitor-tracker-chart>

          </div>
    </div>
  </sb-card>
</div>
